import { useCallback } from "react";
import { useAuth } from "@clerk/react";
import { api } from "@/lib/api";

export const useAdminApi = () => {
  const { getToken } = useAuth();
  return useCallback(async (method, url, data, extra = {}) => {
    const token = await getToken();
    const r = await api.request({ method, url, data, ...extra, headers: { Authorization: `Bearer ${token}`, ...(extra.headers || {}) } });
    return r.data;
  }, [getToken]);
};
